import {
  BodyText,
  Button,
  HeadingText,
  small,
} from '@unmind/design-system-components-web';
import styled, { css } from 'styled-components';
import { ThemeInterface } from 'styles/lightTheme';
import { rem } from 'polished';
import { Bullhorn, OpenExternalLink } from 'icons';
import { SectionHeadingTitleStyle } from '../styles';

export const ShareFeedbackContainer = styled.section<{ isTeams: boolean }>`
  ${small(css`
    margin-bottom: ${rem(40)};
  `)}

  margin-bottom: ${({ isTeams }) => (isTeams ? rem(40) : rem(80))};
`;

const SectionHeadingTitleAttrs = ({ theme }: { theme: ThemeInterface }) => ({
  level: 2,
  color: theme.colors.text.primary,
  sizes: [theme.typography.fontSizes.fontSize16],
  weight: theme.typography.fontWeights.semiBold,
});

export const SectionHeadingTitle = styled(HeadingText).attrs(
  SectionHeadingTitleAttrs,
)`
  ${SectionHeadingTitleStyle}
  margin-bottom: ${rem(10)};
`;

export const ShareFeedbackBanner = styled.div`
  background-color: ${({ theme }) => theme.colors.background.secondary};
  padding: ${rem(20)};
  border-radius: ${({ theme }) => theme.layout.borderRadii.radius16}px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ShareFeedbackBannerIcon = styled(Bullhorn)`
  width: ${rem(24)};
  height: ${rem(24)};
  margin-bottom: ${rem(20)};
`;

export const ShareFeedbackBannerTitle = styled(HeadingText).attrs(
  ({ theme }: { theme: ThemeInterface }) => ({
    level: 3,
    color: theme.colors.text.primary,
    sizes: [theme.typography.fontSizes.fontSize20],
    weight: theme.typography.fontWeights.semiBold,
  }),
)`
  line-height: 1.1;
  margin-bottom: ${rem(10)};
  text-align: center;
  margin-bottom: ${rem(14)};
`;

export const ShareFeedbackBannerDescription = styled(BodyText).attrs(
  ({ theme }: { theme: ThemeInterface }) => ({
    color: theme.colors.text.primary,
    sizes: [theme.typography.fontSizes.fontSize14],
    weight: theme.typography.fontWeights.regular,
  }),
)`
  line-height: 1.3;
  text-align: center;
  margin-bottom: ${rem(20)};
`;

export const ShareFeedbackBannerButton = styled(Button)`
  &:focus {
    outline: none;
  }
`;

export const ShareFeedbackBannerButtonContainer = styled.span`
  display: flex;
  align-items: center;
`;

export const ExternalLinkIcon = styled(OpenExternalLink).attrs(() => ({
  primaryColor: 'currentColor',
}))`
  margin-left: ${rem(4)};
  height: ${rem(18)};
  width: ${rem(18)};
`;
